import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { MeetingReportIdContainer, IDButton } from "./MeetingReportId.styled";
import AddEditMeetingReport from "../../../AddEditMeetingReport/AddEditMeetingReport";

const MeetingReportId = (props) => {
  const { t, id, updateRefeshStatus, countryId } = props;
  const [isEditMode, setIsEditMode] = useState(false);
  const [isViewMode, setIsViewMode] = useState(true);
  const [isEditAnalyticalPopupVisible, setIsEditMeetingReportPopupVisible] =
    useState(false);

  const onMeetingReportIdClick = () => {
    setIsEditMeetingReportPopupVisible(true);
  };

  const closeSolutionEditPopup = () => {
    setIsEditMode(false);
    setIsViewMode(true);
    setIsEditMeetingReportPopupVisible(false);
  };

  const togglePopUp = () => {
    setIsEditMode(!isEditMode);
    setIsViewMode(!isViewMode);
  };

  return (
    <MeetingReportIdContainer>
      <IDButton onClick={onMeetingReportIdClick}>{id}</IDButton>
      {isEditAnalyticalPopupVisible && (
        <AddEditMeetingReport
          id={id}
          title={t("MEETING_REPORT")}
          onClose={closeSolutionEditPopup}
          isEditMode={isEditMode}
          isViewMode={isViewMode}
          togglePopUp={togglePopUp}
          updateRefeshStatus={updateRefeshStatus}
          countryId={countryId}
        />
      )}
    </MeetingReportIdContainer>
  );
};

MeetingReportId.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(MeetingReportId);
